<script lang="ts">
	import type { Breadcrumb } from "@core/schema/Breadcrumb.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import StructuredData from "./common/StructuredData.svelte";

	const { WEB_URL } = getGlobalSettings();
	const { breadcrumbs }: { breadcrumbs: Breadcrumb[] } = $props();
</script>

{#if breadcrumbs.length > 0}
	<StructuredData
		data={{
			"@type": "BreadcrumbList",
			itemListElement: breadcrumbs.map(({ label, href }, index) => ({
				"@type": "ListItem" as const,
				position: index + 1,
				name: label,
				item: href && `${WEB_URL}${href}`,
			})),
		}}
	/>
{/if}
